import React, { useState, useRef, useEffect, useContext } from "react";
import "../../../assests/css/admin/AdmisDispute.css";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";

const DISPUTE_CATEGORIES = ["All", "Fee Issue", "Exam Issue", "Attendance"];

function AdminDisputeChat() {
    const { baseUrl } = useContext(AppContext);
    const [disputes, setDisputes] = useState([]);
    const [selectedDisputeId, setSelectedDisputeId] = useState(null);
    const [activeCategory, setActiveCategory] = useState("All");
    const [messages, setMessages] = useState([]);

    const [replyText, setReplyText] = useState("");
    const [mobileView, setMobileView] = useState("list"); // "list" | "chat"
    const messagesEndRef = useRef(null);

    const selectedDispute = disputes.find(
        (dispute) => dispute.id === selectedDisputeId
    );
    const fetchConversations = () => {
        axios
            .post(baseUrl + "/chat/getAdminConversations")
            .then((response) => {
                if (response.data.success) {
                    setDisputes(response.data.conversations);

                    if (response.data.conversations.length > 0) {
                        setSelectedDisputeId(response.data.conversations[0].id);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const fetchMessages = () => {
        axios.post(baseUrl + "/chat/getMessages", {
            conversation_id: selectedDisputeId
        })
            .then((response) => {
                setMessages(response.data.messages);
            });
    };

    const filteredDisputes =
        activeCategory === "All"
            ? disputes
            : disputes.filter((dispute) => dispute.helpSupport?.selectissue === activeCategory);

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [selectedDisputeId, disputes]);

    const handleSelectDispute = (disputeId) => {
        setSelectedDisputeId(disputeId);
        setDisputes((previousDisputes) =>
            previousDisputes.map((dispute) =>
                dispute.disputeId === disputeId
                    ? { ...dispute, unreadCount: 0 }
                    : dispute
            )
        );
        setMobileView("chat");
    };

    const handleBackToList = () => {
        setMobileView("list");
    };

    const handleSendReply = () => {
        if (!replyText.trim()) return;

        const admin = JSON.parse(localStorage.getItem("admin"));

        axios.post(baseUrl + "/chat/adminReply", {
            conversation_id: selectedDisputeId,
            sender_id: admin.id,
            message: replyText
        })
            .then((response) => {
                if (response.data.success) {
                    setReplyText("");
                    fetchMessages();
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleReplyKeyDown = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            handleSendReply();
        }
    };

    const getStatusClass = (status) => {
        if (status === "Resolved") return "adc-status-resolved";
        if (status === "In Progress") return "adc-status-progress";
        return "adc-status-open";
    };

    useEffect(() => {
        fetchConversations();
    }, []);

    useEffect(() => {
        if (selectedDisputeId) {
            fetchMessages();
        }
    }, [selectedDisputeId]);

    return (
        <div className="adc-page">
            <div
                className={`adc-layout ${mobileView === "chat" ? "adc-layout-chat-active" : ""
                    }`}
            >
                {/* Sidebar: category tabs + dispute list */}
                <aside className="adc-sidebar">
                    <div className="adc-sidebar-header">
                        <h2 className="adc-sidebar-title">All Disputes</h2>
                        <span className="adc-sidebar-count">{disputes.length}</span>
                    </div>

                    <div className="adc-category-tabs">
                        {DISPUTE_CATEGORIES.map((category) => (
                            <button
                                key={category}
                                type="button"
                                className={`adc-category-tab ${activeCategory === category ? "adc-category-tab-active" : ""
                                    }`}
                                onClick={() => setActiveCategory(category)}
                            >
                                {category}
                            </button>
                        ))}
                    </div>

                    <ul className="adc-dispute-list">
                        {filteredDisputes.map((dispute) => (
                            <li key={dispute.id}>
                                <button
                                    type="button"
                                    className={`adc-dispute-item ${dispute.id === selectedDisputeId
                                        ? "adc-dispute-item-active"
                                        : ""
                                        }`}
                                    onClick={() => handleSelectDispute(dispute.id)}
                                >
                                    <div className="adc-dispute-item-top">
                                        <span className="adc-dispute-category-pill">
                                            {dispute.helpSupport?.selectissue}
                                        </span>
                                        {dispute.unreadCount > 0 && (
                                            <span className="adc-unread-badge">
                                                {dispute.unreadCount}
                                            </span>
                                        )}
                                    </div>
                                    {dispute.helpSupport?.selectissue}
                                    <p className="adc-dispute-subject">{dispute.helpSupport?.describeissue}</p>
                                    <span className="adc-dispute-time">{dispute.created_at}</span>
                                </button>
                            </li>
                        ))}

                        {filteredDisputes.length === 0 && (
                            <li className="adc-empty-list">No disputes in this category.</li>
                        )}
                    </ul>
                </aside>

                {/* Chat area */}
                <section className="adc-chat-area">
                    {selectedDispute ? (
                        <>
                            <div className="adc-chat-header">
                                <button
                                    type="button"
                                    className="adc-back-button"
                                    onClick={handleBackToList}
                                    aria-label="Back to dispute list"
                                >
                                    ←
                                </button>
                                <div className="adc-chat-header-info">
                                    <p className="adc-chat-header-name">
                                        {selectedDispute.Student}
                                    </p>
                                    <p className="adc-chat-header-meta">
                                        {selectedDispute.rollNumber} · {selectedDispute.subject}
                                    </p>
                                </div>
                                <span
                                    className={`adc-status-badge ${getStatusClass(
                                        selectedDispute.status
                                    )}`}
                                >
                                    {selectedDispute.status}
                                </span>
                            </div>

                            <div className="adc-messages">
                                {messages.map((message) => (
                                    <div
                                        key={message.id}
                                        className={`adc-message-row ${message.sender_role === "admin"
                                            ? "adc-message-row-admin"
                                            : "adc-message-row-student"
                                            }`}
                                    >
                                        <div
                                            className={`adc-message-bubble ${message.sender_role === "admin"
                                                ? "adc-message-bubble-admin"
                                                : "adc-message-bubble-student"
                                                }`}
                                        >
                                            <p className="adc-message-text">
                                                {message.message}
                                            </p>

                                            <span className="adc-message-time">
                                                {message.created_at}
                                            </span>
                                        </div>
                                    </div>
                                ))}

                                <div ref={messagesEndRef} />
                            </div>

                            <div className="adc-reply-box">
                                <textarea
                                    className="adc-reply-input"
                                    placeholder="Type your reply…"
                                    value={replyText}
                                    onChange={(event) => setReplyText(event.target.value)}
                                    onKeyDown={handleReplyKeyDown}
                                    rows={1}
                                />
                                <button
                                    type="button"
                                    className="adc-send-button"
                                    onClick={handleSendReply}
                                    disabled={!replyText.trim()}
                                >
                                    Send
                                </button>
                            </div>
                        </>
                    ) : (
                        <div className="adc-no-dispute-selected">
                            <p>Select a dispute to view the conversation.</p>
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
}

export default AdminDisputeChat;